export let VideoSource = /*#__PURE__*/function (VideoSource) {
  VideoSource["Youtube"] = "youtube";
  VideoSource["Vimeo"] = "vimeo";
  VideoSource["Loom"] = "loom";
  VideoSource["Unsupported"] = "unsupported";
  return VideoSource;
}({});
export const videoPlayerBorderRadius = '8px';
export const getVideoSource = parsedVideoLink => {
  const hostname = parsedVideoLink.hostname;
  const youtubeHostnames = ['www.youtube.com', 'youtube.com', 'youtu.be'];
  const vimeoHostname = ['vimeo.com'];
  const loomHostnames = ['www.loom.com', 'loom.com'];
  if (youtubeHostnames.includes(hostname)) {
    return VideoSource.Youtube;
  } else if (vimeoHostname.includes(hostname)) {
    return VideoSource.Vimeo;
  } else if (loomHostnames.includes(hostname)) {
    return VideoSource.Loom;
  } else {
    return VideoSource.Unsupported;
  }
};
export function sanitizeUrl(url, videoSource) {
  if (videoSource === VideoSource.Youtube) {
    const parsedUrl = new URL(url);
    const videoIdKey = 'v';
    const playlistIdKey = 'list';
    if (parsedUrl.searchParams.has(videoIdKey)) {
      parsedUrl.searchParams.delete(playlistIdKey);
    }
    return parsedUrl.toString();
  }
  return url;
}
export function extractReactPlayerVideoName(videoLink, reactPlayer) {
  const source = getVideoSource(new URL(videoLink));
  const internalPlayer = reactPlayer.getInternalPlayer();
  if (source === VideoSource.Youtube) {
    var _internalPlayer$getVi;
    return (_internalPlayer$getVi = internalPlayer.getVideoData) === null || _internalPlayer$getVi === void 0 ? void 0 : _internalPlayer$getVi.call(internalPlayer).title;
  }
  if (source === VideoSource.Vimeo) {
    var _internalPlayer$eleme;
    return (_internalPlayer$eleme = internalPlayer.element) === null || _internalPlayer$eleme === void 0 ? void 0 : _internalPlayer$eleme.title;
  }
  throw new Error('Unsupported video source');
}